import { Component, OnInit } from '@angular/core';
import { SearchService, HomeService, ContextService, PagerService } from '../services';
import { Filter } from '../models';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  providers: [SearchService, PagerService]
})
export class ListComponent implements OnInit {

  get query(): string{
    return this.searchService.query;
  }

  set query(value: string){
    this.searchService.query = value;
  }

  constructor(
    private homeService: HomeService,
    private searchService: SearchService,
    private pagerService: PagerService,
    private route: ActivatedRoute,
    private contextService: ContextService,
    private router: Router,
    // private _router: Router,
  ) { 
    window.scrollTo(0, 0);
    
  }

  body: any = {};
  results:any;
  editeur:number;
  facets:any;
  oeuvres:Array<any> = [];
  filtered:Array<any> = [];
  filters: Filter[];
  editeurs:Array<any> = [];
  niveaux:Array<string> = [];
  disciplines:Array<string> = [];
  classes:Array<string> = [];
  types:Array<any> = [];
  imgfolder_url:string;
  loading:boolean = true;
  url:string;
  params:any={};
  context:string='';
  context_root:string='';
  
  Arr = Array;
  pager: any = {};
  played_items: any[];

  editeur_info:Array<any> = [];

  finishedLoading: boolean = true;
  lastSelected: number;
  hideDis: boolean = true;
  hideEd: boolean = true;
  hideNiv: boolean = true;
  hideType: boolean = true;
  hideCl: boolean = true;

  ngOnInit() {

    this.router.routeReuseStrategy.shouldReuseRoute = function(){
        return false;
    };

    this.router.events.subscribe((evt) => {
        if (evt instanceof NavigationEnd) {
            this.router.navigated = false;
            window.scrollTo(0, 0);
        }
    });

    this.url = this.route.snapshot.url[0].path;
    this.context=this.contextService.getContext();
    this.imgfolder_url=environment.imgfolder_url;
    this.context_root=(this.context=='B2B')?'':'/familles';

    if( this.url == 'recherche' ){

      this.query = this.route.snapshot.paramMap.get('query');

    } else {
      if( this.url == 'editeur' ){

        this.editeur = +this.route.snapshot.paramMap.get('id');
        
        sessionStorage.setItem('search_request_hachette_kne', JSON.stringify({
          marche: this.context,
          page:1,
          editeur: [this.editeur],
          niveau: [],
          classe: [],
          typeArticle: [],
          discipline: []
        }));        

      } else {

        let niveau: number;

        switch(this.url){
          case 'primaire':
            niveau = 1;
            break;
          case 'college':
            niveau = 2;
            break;
          case 'lycee':
            niveau = 3;
            break;
          case 'lycee-pro':
            niveau = 4;
            break;
          case 'post-bac':
            niveau = 5;
            break;
          case 'fle':
            niveau = 6;
            break;
        }

        let prevSearch = JSON.parse(sessionStorage.getItem('search_request_hachette_kne'));

        if(prevSearch == null || prevSearch.niveau.length != 1 || prevSearch.niveau[0] != niveau){
          sessionStorage.setItem('search_request_hachette_kne', JSON.stringify({
            marche: this.context,
            page:1,
            editeur: [],
            niveau: [niveau],
            classe: [],
            typeArticle: [],
            discipline: []
          }));
        }

      }

      if(!this.loading){
        this.pager = this.pagerService.getPager(this.params.totalresultats, 1);
        this.setPage(1);
      }
      

      // console.log(JSON.parse(sessionStorage.getItem('search_request_hachette_kne')));
    }

    this.homeService.getAllEditeurs()
      .subscribe(editeurs => {
        this.editeurs = editeurs;
        if(this.editeur ){
            let editeur_current= this.editeurs.find( e => e.id == this.editeur );
           if(editeur_current) this.editeur_info =editeur_current;
          // console.log(this.editeur_info)

        }
        
    });

    this.homeService.getAllNiveaux()
      .subscribe(niveaux => {
        this.niveaux = niveaux;
    });

    this.homeService.getAllDisciplines()
      .subscribe(disciplines => {
        this.disciplines = disciplines;
    });

    this.homeService.getAllClasses()
      .subscribe(classes => {
        this.classes = classes;
    });

    this.homeService.getAllTypes()
      .subscribe(types => {
        this.types = types;
        this.types = this.types.filter( t => t.publication == true );
    });

  	this.searchService.getSearchResults()
  		.subscribe(data => {
       // console.log(data)
  			this.results = data;
        this.oeuvres = this.results.grouped.idOeuvre.groups;
        this.filtered = this.oeuvres;
        this.facets = this.results.facet_counts.facet_fields;
        this.loading=false;
        this.params.totalresultats = this.results.responseHeader.params.nbreOeuvres;
        this.params.pageencours = this.results.responseHeader.params.pageCourante;
        this.params.totalpages = this.results.responseHeader.params.nbrePages;
        
        this.body = JSON.parse(sessionStorage.getItem('search_request_hachette_kne'));
        (this.body.editeur[0] === null || this.body.editeur[0] === 0 || this.body.editeur.length == 0) ? this.body.editeur = [] : this.hideEd = false;
        (this.body.niveau[0] === null || this.body.niveau[0] === 0 || this.body.niveau.length == 0) ? this.body.niveau = [] : this.hideNiv = false;
        (this.body.classe[0] === null || this.body.classe[0] === 0 || this.body.classe.length == 0) ? this.body.classe = [] : this.hideCl = false;
        (this.body.typeArticle[0] === null || this.body.typeArticle[0] === 0 || this.body.typeArticle.length == 0) ? this.body.typeArticle = [] : this.hideType = false;
        (this.body.discipline[0] === null || this.body.discipline[0] === 0 || this.body.discipline.length == 0) ? this.body.discipline = [] : this.hideDis = false;
        this.pager = this.pagerService.getPager(this.params.totalresultats, 1);
        //this.setPage(1);

        /// cocher par défaut le niveau s'il est seul
        if( Object.keys(this.facets.idNiveauScolaire).length==1) {
          this.body.niveau[0]=(Number(Object.keys(this.facets.idNiveauScolaire)[0]));
        }
  	});

  }

  filterSearch(id, filter, type){
    this.lastSelected = id;
    this.finishedLoading = false;
    // console.log(filter)
    var temp = this.body;
    if(filter.target && filter.target.checked){
      
      switch(type){
        case 'type':
          temp.typeArticle.push(+filter.target.value);
          break;
        case 'niveau':
          temp.niveau.push(+filter.target.value);
          break;
        case 'classe':
          temp.classe.push(+filter.target.value);
          break;
        case 'discipline':
          temp.discipline.push(+filter.target.value);
          break;
        case 'editeur':
          temp.editeur.push(+filter.target.value);
          break;
         
      }

    } else {

      switch(type){
        case 'type':
          temp.typeArticle = temp.typeArticle.filter( item => item != filter.target.value );
          break;
        case 'niveau':
          temp.niveau = temp.niveau.filter( item => item != filter.target.value );
          break;
        case 'classe':
          temp.classe = temp.classe.filter( item => item != filter.target.value );
          break;
        case 'discipline':
          temp.discipline = temp.discipline.filter( item => item != filter.target.value );
          break;
        case 'editeur':
          temp.editeur = temp.editeur.filter( item => item != filter.target.value );
          break;
         case 'page':
           temp.page = filter;
          break;  
      }

    }

    if(type!='page') temp.page=1
    
    sessionStorage.setItem('search_request_hachette_kne', JSON.stringify(temp));
    this.searchService.getSearchResults()
      .subscribe(data => {
        if(type=="page") window.scrollTo(0, 0);
        this.results = data;
        this.oeuvres = this.results.grouped.idOeuvre.groups;
        this.filtered = this.oeuvres;
        this.facets = this.results.facet_counts.facet_fields;
        this.params.totalresultats = this.results.responseHeader.params.nbreOeuvres;
        this.params.pageencours = this.results.responseHeader.params.pageCourante;
        this.params.totalpages = this.results.responseHeader.params.nbrePages;
        this.loading=false;
        this.body = JSON.parse(sessionStorage.getItem('search_request_hachette_kne'));
        (this.body.editeur[0] === null || this.body.editeur[0] === 0 || this.body.editeur.length == 0) ? this.body.editeur = [] : this.hideEd = false;
        (this.body.niveau[0] === null || this.body.niveau[0] === 0 || this.body.niveau.length == 0) ? this.body.niveau = [] : this.hideNiv = false;
        (this.body.classe[0] === null || this.body.classe[0] === 0 || this.body.classe.length == 0) ? this.body.classe = [] : this.hideCl = false;
        (this.body.typeArticle[0] === null || this.body.typeArticle[0] === 0 || this.body.typeArticle.length == 0) ? this.body.typeArticle = [] : this.hideType = false;
        (this.body.discipline[0] === null || this.body.discipline[0] === 0 || this.body.discipline.length == 0) ? this.body.discipline = [] : this.hideDis = false;
        this.pager = this.pagerService.getPager(this.params.totalresultats, temp.page);

        console.log(Object.keys(this.facets.idNiveauScolaire).length)
        /// cocher par défaut le niveau s'il est seul
        if( Object.keys(this.facets.idNiveauScolaire).length==1) {
          this.body.niveau[0]=(Number(Object.keys(this.facets.idNiveauScolaire)[0]));
        }else{
          this.url='recherche';
        }

      
        this.finishedLoading = true;
    });
  }

  emptyFilter(type, filter){
    switch(type){

      case 'type':
        // return this.oeuvres.filter( item => item.doclist.docs[0].typeArticle[0] == filter ).length === 0;
        for(var key in this.facets.typeArticle){
          if(key == filter){
            return false;
          }
        }
        return true;

      case 'niveau':
        // return this.oeuvres.filter( item => item.doclist.docs[0].idNiveauScolaire[0] == filter ).length === 0;
        for(var key in this.facets.idNiveauScolaire){
          if(key == filter){
            return false;
          }
        }
        return true;

      case 'classe':
        // return this.oeuvres.filter( item => item.doclist.docs[0].idClasseDiplome[0] == filter ).length === 0;
        for(var key in this.facets.idClasseDiplome){
          if(key == filter){
            return false;
          }
        }
        return true;

      case 'discipline':
        // return this.oeuvres.filter( item => item.doclist.docs[0].idDiscipline[0] == filter ).length === 0;
        for(var key in this.facets.idDiscipline){
          if(key == filter){
            return false;
          }
        }
        return true;

      case 'editeur':
        // return this.oeuvres.filter( item => item.doclist.docs[0].idEditeur == filter ).length === 0;
        for(var key in this.facets.idEditeur){
          if(key == filter){
            return false;
          }
        }
        return true;

      default:
        console.log('filter_error', 'Wrong filter type.');
        break;
    }
  }

  setPage(page: number){
    //console.log(this.pager);
    if(page < 1 || page > this.pager.totalPages){
      return;
    }

    
    this.filterSearch(0, page, 'page');
  }

  develop(type: string){
    console.log('meh' + ' ' + type + ' ' + this.hideDis)
    if(type == 'dis') this.hideDis = false;
    if(type == 'ed') this.hideEd = false;
    if(type == 'type') this.hideType = false;
    if(type == 'cl') this.hideCl = false;
    if(type == 'niv') this.hideNiv = false;
  }

  reduce(type: string){
    if(type == 'dis') this.hideDis = true;
    if(type == 'ed') this.hideEd = true;
    if(type == 'type') this.hideType = true;
    if(type == 'cl') this.hideCl = true;
    if(type == 'niv') this.hideNiv = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/list/list.component.ts